// extracted by mini-css-extract-plugin
module.exports = {"ContentList":"styles_ContentList__USa4e","bg_1":"styles_bg_1__XDVwI","bg_2":"styles_bg_2__K7mYC","height":"styles_height__ZhVgq"};